import { RouteRecordRaw } from 'vue-router'

const Invoices = () =>
  import(/* webpackChunkName: "invoices-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'facturas',
    name: 'invoices',
    component: Invoices,
    meta: {
      title: 'Facturas',
      auth: {
        requiredPermission: 'invoices.view',
        requiredModule: 'invoices',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
